<template>
    <div class="responsive-menu">
        <div class="responsive-inner">
            <AvailableFundWidget v-if="typeAccount != 'OFFLINE_BILLING' && availableFundsWidgetAccess"></AvailableFundWidget>
            <SidebarNav :navItems="nav"></SidebarNav>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import Axios from 'axios';
import globalStore from '../variables';
import nav from "@/_nav";
import VueSession from "vue-session";
import VueCookies from "vue-cookies";
import AvailableFundWidget from "./../views/payments/AvailableFunds";
import { SidebarNav } from "@coreui/vue";
import keycloak from "../main";

Vue.use(VueSession);
Vue.use(VueCookies);
Vue.$cookies.config('7d','','',true)

export default {
    name: 'ResponsiveMenu',
    data() {
        return {
            nav: [],
            userLevelId: 0,
            availableFundsWidgetAccess: false,
            permissions: []
        }
    },
    components: {
        AvailableFundWidget,
        SidebarNav
    },
    methods: {
        getUserData() {
            if (this.$session.get('typeAccount') != '' && this.$session.get('typeAccount') != undefined) {
                this.typeAccount = this.$session.get('typeAccount')
            } else {
                this.typeAccount = this.$cookies.get('typeAccount')
            }
        },
        logout() {
            if (this.$cookies.get('token')) {
                this.$cookies.remove('token')
                this.$cookies.remove('refreshToken')
                this.$cookies.remove('refreshFlag')
                this.$cookies.remove('defaultLogin')
                this.$cookies.remove('lastActiviti')
                this.$cookies.remove('multiCompanyAccess')
                this.$cookies.remove('multiCompanyAccessId')
                this.$cookies.remove('isSA')
                this.$cookies.remove('tokenSetTime')
                this.$cookies.remove('userId')
                this.$cookies.remove('userLevelId')
                this.$cookies.remove('userEmail')
                this.$cookies.remove('userLevel')
                this.$cookies.remove('permissions')
                this.$cookies.remove('firstName')
                this.$cookies.remove('lastName')
                this.$cookies.remove('companyId')
                this.$cookies.remove('companyName')
                this.$cookies.remove('typeAccount')
                this.$cookies.remove('simonCarrierAvailable')
                this.$cookies.remove('tmobileCarrierAvailable')
                this.$cookies.remove('vodafoneCarrierAvailable')
                this.$cookies.remove('koreCarrierAvailable')
                this.$cookies.remove('nbIoTPlans')
                this.$cookies.remove('voiceAccess')
                this.$cookies.remove('tier2Roaming')
                this.$cookies.remove('catM1Plans')
                this.$cookies.remove('simonActiveReady')
                this.$cookies.remove('coldStockAccess')
                this.$cookies.remove('hotSpotAccess')
                this.$cookies.remove('acceptedAgreementId')
            } else if (this.$session.get('token')) {
                this.$cookies.remove('defaultLogin')
                this.$session.destroy()
            }
            this.$router.push("/login");
        },
        checkPermission(permission) {
            let ret = false
            if (permission.permission == null) {
                ret = true
            } else if (typeof permission.permission == 'string') {
                if (this.permissions.indexOf(permission.permission) > -1) {
                    ret = true
                }
            } else if (typeof permission.permission == 'object') {
                let isAll = 0
                for (let item of permission.permission) {
                    if (this.permissions.indexOf(item) > -1) {
                        isAll++
                    }
                }
                if (isAll) {
                    ret = true
                }
            }
            return ret
        },
        setMenuItems() {
            this.nav = [];
            if ((keycloak.token || this.$session.get('token') || this.$cookies.get('token')) && this.$cookies.get('isSA') == 'false') {
                this.permissions = this.$cookies.get('permissions').split(',')
                for (let item of nav.items) {
                    if (this.checkPermission(item)) {
                        if (item.children) {
                            let childrenTemplate = []
                            for (let childItem of item.children) {
                                if (this.checkPermission(childItem)) {
                                    childrenTemplate.push(childItem)
                                }
                            }
                            let tempItem = {
                                name: item.name,
                                url: item.url,
                                icon: item.icon,
                                permission: item.permission,
                            }
                            tempItem.children = childrenTemplate
                            if (tempItem.name == 'Order') {
                                if (this.typeAccount != 'OFFLINE_BILLING') {
                                    this.nav.push(tempItem)
                                }
                            } else {
                                this.nav.push(tempItem)
                            }
                        } else {
                            this.nav.push(item)
                        }
                    }
                }

                if ((this.userLevelId == 1 || this.userLevelId == 9) && ((this.permissions.indexOf('AFFILIATE_PROGRAM_READ') > -1) || this.permissions.indexOf('SUPER_ADMIN_PANEL') > -1)) {
                    Axios.get(globalStore.data.restApiUrl + '/affiliate/customer/is-approved?companyId=' + this.$cookies.get('companyId'))
                        .then(response => {
                            if (response.data == true) {
                                let index = null
                                let billingIndex = false
                                let settingsIndex = false
                                for (let i = 0; i < this.nav.length; i++) {
                                    if (this.nav[i].name == 'Billing') {
                                        billingIndex = i
                                    }
                                    if (this.nav[i].name == 'Settings') {
                                        settingsIndex = i
                                    }
                                }
                                if (billingIndex) {
                                    index = billingIndex
                                } else if (settingsIndex) {
                                    index = settingsIndex
                                } else {
                                    index = this.nav.length - 1
                                }
                                this.nav.splice(index, 0, {
                                    name: 'Affiliate Program',
                                    url: '/affiliate-program',
                                    icon: 'fa fa-pie-chart'
                                });
                            }
                        })
                }
                this.checkAvailableFundsWidgetAccess()
            } else if ((keycloak.token || this.$session.get('token') || this.$cookies.get('token')) && this.$session.get('isSA')) {
                this.permissions = this.$session.get('saPermissions')
                for (let item of nav.items) {
                    if (this.checkPermission(item)) {
                        if (item.children) {
                            let childrenTemplate = []
                            for (let childItem of item.children) {
                                if (this.checkPermission(childItem.permission)) {
                                    childrenTemplate.push(childItem)
                                }
                            }
                            let tempItem = {
                                name: item.name,
                                url: item.url,
                                icon: item.icon,
                                permission: item.permission,
                            }
                            tempItem.children = childrenTemplate
                            if (tempItem.name == 'Order') {
                                if (this.typeAccount != 'OFFLINE_BILLING') {
                                    this.nav.push(tempItem)
                                }
                            } else {
                                this.nav.push(tempItem)
                            }
                        } else {
                            this.nav.push(item)
                        }
                    }
                }
                this.checkAvailableFundsWidgetAccess()
            } else {
                this.$router.push('/login')
            }
        },
        checkAvailableFundsWidgetAccess() {
            if (this.permissions.indexOf('BILLING_READ') > -1 || this.permissions.indexOf('BILLING_WRITE') > -1 || this.permissions.indexOf('SUPER_ADMIN_PANEL') > -1) {
                this.availableFundsWidgetAccess = true
            } else {
                this.availableFundsWidgetAccess = false
            }
        }
    },
    mounted() {
        this.getUserData()

        this.userLevelId = Number(this.$cookies.get('userLevelId')) ? Number(this.$cookies.get('userLevelId')) : this.$session.get('userLevelId')

        this.setMenuItems()
    }
}
</script>

<style lang="scss">

.visible-menu~.app-body {
    pointer-events: none;
    touch-action: none;
}

.responsive-menu {
    width: 100vw;
    right: 100vw;
    max-height: 100vh;
    position: fixed;
    padding: 55px 0 114px;
    background-color: #2F353A;
    color: #FFFFFF;
    overflow: auto;
    transition: all .6s ease-in;
    box-sizing: border-box;
    z-index: 2090;

    &.visible-menu {
        right: 0;
        transition: all .6s ease-in;
        z-index: 10000;
    }

    .responsive-inner {
        position: relative;
        box-sizing: border-box;
    }

    .user-details-wrapper {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        .user-level-wrapper {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            margin-bottom: 10px;
            .user-role {
                padding: 7px 40px;
                background-color: #FC4D4D;
                border-radius: 0 0 0 9px;
            }
        }

        .user-thumbnail-wrapper {
            margin-bottom: 12px;
            img {
                width: 50px;
                height: auto;
            }
        }

        .user-data-wrapper {
            margin-bottom: 20px;

            .user-name {
                margin-bottom: 6px;
                font-size: 16px;
                line-height: 20px;
                text-align: center;
                color: #fff;
            }

            .user-email {
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                color: #fff;
            }
        }

        .user-logout-button {
            width: 100%;
            padding: 0 20px;
            margin-bottom: 20px;
            .logout-button {
                width: 100%;
                padding: 15px 0;
                background-color: #0088FF;
                border-color: #0088FF;
                color: #fff;
                font-size: 15px;
                font-weight: 700;
            }
        }
    }

    .available-funds-widget {
        padding: 20px;
        margin: 0;
        background-color: #3A4149;
        align-content: center;
        align-items: center;

        .text {
            width: 100%;
            display: flex;
            justify-content: space-between;

            span {
                font-size: 15px;
                color: #fff;
            }

            em {
                font-size: 14px;
                font-weight: 700;
                color: #fff;
            }
        }

        .tooltip-add-funds {
            z-index: 2090;
        }
    }



    .sidebar-nav {
        position: relative;
        section {
            position: relative;

            ul.nav {
                background-color: #434950;
                li {
                    width: 100%;
                    display: block;
                    a,
                    div {
                        display: flex;
                        align-items: center;
                        align-content: center;
                        width: 100%;
                        padding: 16px;
                        color: #fff;
                        font-size: 17px;
                        font-family: 'Trebuchet MS', 'Arial', sans-serif;

                        i {
                            width: 40px;
                        }
                    }

                    ul {
                        padding: 0 0 0 20px;
                        background-color: #3A4149;
                    }
                }
            }
        }
    }
}
</style>
